import {Component} from '@angular/core';
import {LoadingService} from "../../services/loading.service";


@Component({
    selector: 'spinner',
    styleUrls: ['spinner.component.css'],
    templateUrl: 'spinner.component.html'
})
export class SpinnerComponent {
    loading: Boolean = false;
    state = {
        message: 'お待ち下さい。。'
    };

    constructor(loadingService: LoadingService) {
        loadingService.isLoading.subscribe((value) => {
            this.loading = value;
        })
    }
}
